import React from 'react';
import {Container, Row, Col, Button} from 'reactstrap';
import BtnRightSideText from '../../../Shared/Buttons/BtnRightSideText';
import {searchParametersEnum, lobbyTabsEnum} from '../cellcomAbroadVariables';
import gaParams from '../../../../utilities/analytics/constants';
import {gaEvent} from '../../../../utilities/analytics/tracking';

const AllSelectedCountriseAreNotSupportedInPackagePopupContent = (props) => {
  const continueWithSelected = () => {
    switch (props.activeLobbyTab) {
      case lobbyTabsEnum.PRIVATE:
        gaEvent(
          gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_ALL_COUNTRIES_ARE_UNSUPPORTED_POPUP_CONTINUE_TO_DATES_BUTTON_CLICK_PRIVATE_FROM_PACKAGE
            .category,
          gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_ALL_COUNTRIES_ARE_UNSUPPORTED_POPUP_CONTINUE_TO_DATES_BUTTON_CLICK_PRIVATE_FROM_PACKAGE
            .eventType,
          gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_ALL_COUNTRIES_ARE_UNSUPPORTED_POPUP_CONTINUE_TO_DATES_BUTTON_CLICK_PRIVATE_FROM_PACKAGE
            .eventParams
        );
        break;
      case lobbyTabsEnum.BUSINESSACCOUNT:
        if (props.isSeparatedSale) {
          gaEvent(
            gaParams.SEPARATED_FROMPACKAGEDESTINATIONNOTSUPPORTEDCONTINUE_CLICK.category,
            gaParams.SEPARATED_FROMPACKAGEDESTINATIONNOTSUPPORTEDCONTINUE_CLICK.eventType,
            gaParams.SEPARATED_FROMPACKAGEDESTINATIONNOTSUPPORTEDCONTINUE_CLICK.eventParams
          );
        } else {
          gaEvent(
            gaParams
              .ABROAD_LOBBY_SELECT_COUNTRIES_TAB_ALL_COUNTRIES_ARE_UNSUPPORTED_POPUP_CONTINUE_TO_DATES_BUTTON_CLICK_BUSINESS_FROM_PACKAGE
              .category,
            gaParams
              .ABROAD_LOBBY_SELECT_COUNTRIES_TAB_ALL_COUNTRIES_ARE_UNSUPPORTED_POPUP_CONTINUE_TO_DATES_BUTTON_CLICK_BUSINESS_FROM_PACKAGE
              .eventType,
            gaParams
              .ABROAD_LOBBY_SELECT_COUNTRIES_TAB_ALL_COUNTRIES_ARE_UNSUPPORTED_POPUP_CONTINUE_TO_DATES_BUTTON_CLICK_BUSINESS_FROM_PACKAGE
              .eventParams
          );
        }
        break;
      default:
        break;
    }
    props.closeModal();
    props.setSelectedAbroadPackage(null);
    props.saveNotSupportedCountries(null);
    props.getNextStep(searchParametersEnum.DATES);
  };

  const gaReportAndClose = () => {
    switch (props.activeLobbyTab) {
      case lobbyTabsEnum.PRIVATE:
        gaEvent(
          gaParams
            .ABROAD_LOBBY_SELECT_COUNTRIES_TAB_ALL_COUNTRIES_ARE_UNSUPPORTED_POPUP_RETURN_TO_COUNTRIES_BUTTON_CLICK_PRIVATE_FROM_PACKAGE
            .category,
          gaParams
            .ABROAD_LOBBY_SELECT_COUNTRIES_TAB_ALL_COUNTRIES_ARE_UNSUPPORTED_POPUP_RETURN_TO_COUNTRIES_BUTTON_CLICK_PRIVATE_FROM_PACKAGE
            .eventType,
          gaParams
            .ABROAD_LOBBY_SELECT_COUNTRIES_TAB_ALL_COUNTRIES_ARE_UNSUPPORTED_POPUP_RETURN_TO_COUNTRIES_BUTTON_CLICK_PRIVATE_FROM_PACKAGE
            .eventParams
        );
        break;
      case lobbyTabsEnum.BUSINESSACCOUNT:
        if (props.isSeparatedSale) {
          gaEvent(
            gaParams.SEPARATED_FROMPACKAGEDESTINATIONNOTSUPPORTEDCHECKAGAIN_CLICK.category,
            gaParams.SEPARATED_FROMPACKAGEDESTINATIONNOTSUPPORTEDCHECKAGAIN_CLICK.eventType,
            gaParams.SEPARATED_FROMPACKAGEDESTINATIONNOTSUPPORTEDCHECKAGAIN_CLICK.eventParams
          );
        } else {
          gaEvent(
            gaParams
              .ABROAD_LOBBY_SELECT_COUNTRIES_TAB_ALL_COUNTRIES_ARE_UNSUPPORTED_POPUP_RETURN_TO_COUNTRIES_BUTTON_CLICK_BUSINESS_FROM_PACKAGE
              .category,
            gaParams
              .ABROAD_LOBBY_SELECT_COUNTRIES_TAB_ALL_COUNTRIES_ARE_UNSUPPORTED_POPUP_RETURN_TO_COUNTRIES_BUTTON_CLICK_BUSINESS_FROM_PACKAGE
              .eventType,
            gaParams
              .ABROAD_LOBBY_SELECT_COUNTRIES_TAB_ALL_COUNTRIES_ARE_UNSUPPORTED_POPUP_RETURN_TO_COUNTRIES_BUTTON_CLICK_BUSINESS_FROM_PACKAGE
              .eventParams
          );
        }
        break;
      default:
        break;
    }
    props.closeModal();
  };

  return (
    <Container className='not-supported-countries-popup'>
      <Row className='not-supported-countries-popup__upper-text'>
        <Col xs={12} className='text-center'>
          <span className='d-block font-16'>
            החבילה שבחרתם לא נתמכת
            <br />
            <span className='bold'>ביעדים </span>שסימנתם.
          </span>
        </Col>
      </Row>
      <Row className='not-supported-countries-popup__middle-text'>
        <Col xs={12} className='text-center'>
          <span className='bold'>אנחנו ממליצים:</span>
          <br />
          <span className='font-16'>
            שנמשיך את החיפוש. ונציג <br /> לכם את חבילות המתאימות בול לכם.
          </span>
        </Col>
      </Row>
      <Row>
        <Col>
          <BtnRightSideText
            text={`המשך לבחירת תאריכים`}
            isDisplayArrows={true}
            onclick={() => continueWithSelected()}
            customClass={'not-supported-countries-popup__button'}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <Button color='link font-12 not-supported-countries-popup-link-btn' onClick={() => gaReportAndClose()}>
            לבדיקת היעדים שבחרתם
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default AllSelectedCountriseAreNotSupportedInPackagePopupContent;
